export function normalizeShopApprovalStatus(status) {
  return String(status || '').trim().toUpperCase();
}

export function isAlreadyHaveShopError(message) {
  const text = String(message || '');
  return /already have a (designer |boutique |artist )?(shop|boutique|gallery)/i.test(text)
    || /already have a shop/i.test(text)
    || /already have a boutique/i.test(text);
}

/** Owners manage the shop in-app unless admin rejected it (then they re-apply via create). */
export function canOwnerManageShopInPortal(shop) {
  if (!shop?.id) return false;
  return normalizeShopApprovalStatus(shop.approval_status) !== 'REJECTED';
}

/**
 * Public shop payloads omit approval_status. Those shops are already approved
 * (pending/rejected shops 404 on the public detail endpoint).
 */
export function canOwnerAddCatalogItems(shop, isOwner) {
  if (!isOwner || !shop) return false;
  const status = normalizeShopApprovalStatus(shop.approval_status);
  if (status === 'PENDING' || status === 'REJECTED') return false;
  return status === 'APPROVED' || status === '';
}
